import { Suspense } from "react";

import { Space } from "@prisma/client";
import { LatLng, LatLngBounds } from "leaflet";
import { MapContainer, TileLayer, useMap, ZoomControl } from "react-leaflet";

import DATA from "~/data";
import { SpaceProps } from "~/types";

import Layers from "./Layers.client";
import { RefreshCwIcon } from "lucide-react";
import { Button } from "~/components";

export const INIT_ZOOM = 20;
const MIN_ZOOM = 17;
const MAX_ZOOM = 22;
const mapboxStyleId = "mapbox/satellite-v9";
// todo: move token to env file...was having issues importing from config.server
const MAPBOX_ACCESS_TOKEN =
    "pk.eyJ1IjoiZ3JlZ2NvbWVkaWEiLCJhIjoiY2x4dzZjejJ4MHVxNzJxcHVrcm9oMXl2ZSJ9.WHX1qyZTV6K6d2dwMVTWMg";
const mapBoxUrl = `https://api.mapbox.com/styles/v1/${mapboxStyleId}/tiles/{z}/{x}/{y}?access_token=${MAPBOX_ACCESS_TOKEN}`;

export function InnerMap({
    className,
    spaces,
    selectSpace,
    selectedSpace,
}: {
    className?: string;
    spaces: Space[];
    selectSpace: (product: SpaceProps) => void;
    selectedSpace: SpaceProps | null;
}) {
    // this max bounds is for the area we have polygons for
    const maxBounds = new LatLngBounds(DATA.map.bounds);
    const center = new LatLng(DATA.map.center.latitude, DATA.map.center.longitude);

    return (
        <>
            <MapContainer
                className={className}
                key={"once"}
                center={center}
                zoom={INIT_ZOOM}
                minZoom={MIN_ZOOM}
                maxZoom={MAX_ZOOM}
                // maxBounds={maxBounds}
                // maxBoundsViscosity={0.3}
                scrollWheelZoom={true}
                doubleClickZoom={false}
                zoomControl={false}
                dragging={true}
            >
                <Suspense fallback={<div>Loading map...</div>}>
                    <TileLayer
                        minZoom={MIN_ZOOM}
                        maxZoom={MAX_ZOOM}
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url={mapBoxUrl}
                    />
                    <Layers
                        spaces={spaces}
                        selectSpace={selectSpace}
                        selectedSpace={selectedSpace}
                        bounds={maxBounds}
                    />
                    <ZoomControl position="topright" />
                    <RecenterButton center={center} zoom={INIT_ZOOM} />
                </Suspense>
            </MapContainer>
        </>
    );
}

export default function RecenterButton({
    center,
    zoom,
}: {
    center: LatLng;
    zoom: number;
}) {
    const map = useMap();

    return (
        <Button
            style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                position: "absolute",
                top: "12px",
                left: "12px",
                zIndex: 1000,
                background: "white",
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "6px 10px",
                cursor: "pointer",
                fontWeight: "bold",
                color: "black",
            }}
            onClick={() => map.setView(center, zoom)}
        >
            <RefreshCwIcon className="w-4 h-4" />
            <span>Recenter</span>
        </Button>
    );
}
